import { createContext } from '@chakra-ui/react-utils';

export interface PopoverContextType {
  withArrow?: boolean;
}
export const [PopoverContext, usePopoverContext] = createContext<PopoverContextType>();
